
function NavBar({children}) {
 return (
    <>
     <div className="container-bar">
      {children}
      </div>
    </>
  );
}

export default NavBar;
